import UserContext from "@context/UserContext";
import reorderList from "@mappers/Shared/reorderList.mapper";
import { useContext, useEffect, useState } from "react";
import TObjectFilledWithStrings from "types/Shared/objectFilledWithStrings";

const useListItems = <T>(
  getListFunction: Function,
  mapper: any,
  isDeletingItem?: boolean,
  skipReorder = false
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableItems, setTableItems] = useState<T[] | undefined>(undefined);
  const [basicData, setBasicData] = useState<
    TObjectFilledWithStrings | undefined
  >(undefined);
  const { currentUser } = useContext(UserContext);

  const handleSetBasicData = ({
    uuid,
    description,
    verified,
    banned,
    featured,
    actionButtonType,
  }: TObjectFilledWithStrings) => {
    setBasicData({
      uuid,
      description,
      verified,
      banned,
      featured,
      actionButtonType,
    });
  };

  const getItems = () => {
    setIsLoading(true);
    getListFunction()
      .then(async (response: { data: T[] }) => {
        setTableItems(mapper(response.data, handleSetBasicData, currentUser));
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (tableItems) {
      const listFiltered = tableItems?.filter(
        ({ uuid }: any) => uuid !== basicData?.uuid
      );
      !skipReorder
        ? setTableItems(reorderList(listFiltered))
        : setTableItems(listFiltered);
    } else {
      getItems();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeletingItem]);

  return {
    isLoading,
    basicData,
    tableItems,
    getItems,
  };
};

export default useListItems;
